import { z } from 'zod';

export const artifactUploadSchema = z.object({
  artifactFile: z
    .array(z.custom<File>((val) => val instanceof File))
    .min(1, 'Please upload the required SAP library archive.')
    .max(1, 'You can only upload one library archive package at a time.')
    .refine(
      (files) => {
        if (!files || files.length === 0 || !files[0]) {
          return true;
        }
        return files[0].name.toLowerCase().endsWith('.zip');
      },
      {
        message: 'The uploaded file package must be a compressed ZIP archive (.zip).',
      },
    ),
});

export type ArtifactUploadFormValues = z.infer<typeof artifactUploadSchema>;
